// Value-type keys requested from /values and read back from the response for pest dashboards.
// Keep request (useDashboardValues) and response (buildPestTimingChartOptions) reading the same keys.

export const trapCatchKeyForInsect = (insectId: number) => `insectTrapCatches_${insectId}`

export const degreeDaysKeyForInsect = (insectId: number) =>
  `insectDegreeDaysCumulativeSinceBiofix_${insectId}`

// Phenology (spray windows + modeled flights). Property-scoped, UNAGGREGATED. Only defined for
// insects with a phenology model: CM (1), OFM (7), OBLR (11).
export const phenologyKeyForInsect = (insectId: number) => `insectPhenology_${insectId}`

// Crop-event value types (not insect-keyed). Bloom is block-scoped (value = bloom %, the 1%
// bloom date is metadata.overrideDate); hull split is property-scoped (value = ISO date per cultivar).
export const ALMOND_BLOOM_KEY = 'almondBloom'

export const ALMOND_HULL_SPLIT_KEY = 'almondHullSplit'
